<template>
    <!-- Previous deleted organizations -->
    <b-container fluid class="overview">
        <h1 class="text-left">
            {{ $t('product.overview') }}
        </h1>
        <h4>Productversies</h4>
        <div v-if="!loading && productVersions && productVersions.length > 0">
            <b-table
                id="table-function-results"
                striped
                hover
                small
                outlined
                bordered
                :sticky-header="btableMaxHeight"
                :select-mode="'single'"
                tbody-tr-class="tablerow"
                :items="productVersions"
                :fields="productFields"
                sort-icon-left
            >
                <template v-slot:cell(assign)="{ item }">
                    <b-button
                        size="sm"
                        variant="secondary"
                        @click="$_assign(item)"
                        :title="$t('product.assignTitle')"
                    >
                        {{ $t('product.assign') }}
                    </b-button>
                </template>
                <template v-slot:cell(export)="{ item }">
                    <b-button
                        size="sm"
                        variant="secondary"
                        @click="$_export(item)"
                        :title="$t('product.exportTitle')"
                    >
                        {{ $t('product.export') }}
                    </b-button>
                </template>
                <template v-slot:cell(delete)="{ item }">
                    <b-button
                        size="sm"
                        variant="secondary"
                        @click="$_delete(item)"
                        :title="$t('product.deleteTitle')"
                    >
                        {{ $t('product.delete') }}
                    </b-button>
                </template>
            </b-table>
        </div>
        <div v-if="!loading && productVersions && productVersions.length == 0">
            {{ $t('product.noData') }}
        </div>
        <br />
        <h4>Toegekende productversies</h4>
        <div
            v-if="
                !loading &&
                organizationProductContents &&
                organizationProductContents.length > 0
            "
        >
            <b-table
                id="table-function-results"
                striped
                hover
                small
                outlined
                bordered
                :sticky-header="btableMaxHeight"
                :select-mode="'single'"
                tbody-tr-class="tablerow"
                :items="organizationProductContents"
                :fields="organizationProductContentsFields"
                sort-icon-left
            >
                <template v-slot:cell(delete)="{ item }">
                    <b-button
                        size="sm"
                        variant="secondary"
                        @click="$_deleteAssignment(item)"
                        :title="$t('product.deleteAssignmentTitle')"
                    >
                        {{ $t('product.delete') }}
                    </b-button>
                </template>
            </b-table>
        </div>
        <div
            v-if="
                !loading &&
                organizationProductContents &&
                organizationProductContents.length == 0
            "
        >
            {{ $t('product.noAssignments') }}
        </div>
        <div class="sticky-bottom fixed-bottom">
            <div class="btn-group">
                <b-button
                    @click="$_productCreate()"
                    id="new_button"
                    variant="primary"
                    class="mr-2"
                    :title="$t('product.createTitle')"
                >
                    {{ $t('product.create') }}
                    <span class="pl-1 fa fa-plus"></span>
                </b-button>
                <b-button
                    id="import_button"
                    class="btn-space-5"
                    :title="$t('product.importTitle')"
                    @click="$_import()"
                >
                    {{ $t('product.import') }}&nbsp;
                    <span class="fa fa-copy"></span>
                </b-button>
            </div>
        </div>
        <product-creation
            :launchModal="launchProductCreate"
            @created="$_created()"
        />
        <product-assign
            :launchModal="launchProductAssign"
            :product="selectedProduct"
            @created="$_created()"
        />
        <product-import
            :launchModal="launchProductImport"
            @created="$_created()"
        />
    </b-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { nprogress } from '../../services/utilities';
    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    import ProductCreation from './ProductCreation.vue';
    import ProductAssign from './ProductAssign.vue';
    import ProductImport from './ProductImport.vue';

    export default {
        name: 'ProductsOverview',

        mixins: [modalMixin],

        components: {
            'product-creation': ProductCreation,
            'product-assign': ProductAssign,
            'product-import': ProductImport
        },

        data() {
            return {
                launchProductCreate: false,
                launchProductAssign: false,
                launchProductImport: false,
                loading: true,
                selectedProduct: null,
                productVersions: [],
                productFields: [
                    {
                        key: 'name',
                        label: this.$t('product.product'),
                        sortable: true
                    },
                    {
                        key: 'version',
                        label: this.$t('product.version'),
                        sortable: false
                    },
                    {
                        key: 'dateCreated',
                        label: this.$t('product.dateCreated'),
                        sortable: true,
                        formatter: (value) => {
                            return new Date(value).toLocaleString(
                                this.$store.state.userInfo.locale
                            );
                        }
                    },
                    {
                        key: 'assign',
                        label: '',
                        thStyle: { border: 0, width: '100px' }
                    },
                    {
                        key: 'export',
                        label: '',
                        thStyle: { border: 0, width: '100px' }
                    },
                    {
                        key: 'delete',
                        label: '',
                        thStyle: { border: 0, width: '100px' }
                    }
                ],
                organizationProductContents: [],
                organizationProductContentsFields: [
                    {
                        key: 'productName',
                        label: this.$t('product.product'),
                        sortable: true
                    },

                    {
                        key: 'version',
                        label: this.$t('product.version'),
                        sortable: true
                    },
                    {
                        key: 'organizationName',
                        label: this.$t('labelOrganization'),
                        sortable: true
                    },
                    {
                        key: 'dateAdded',
                        label: this.$t('product.dateAssigned'),
                        sortable: true,
                        formatter: (value) => {
                            return new Date(value).toLocaleString(
                                this.$store.state.userInfo.locale
                            );
                        }
                    },
                    {
                        key: 'delete',
                        label: '',
                        thStyle: { border: 0, width: '100px' }
                    }
                ],
                btableMaxHeight: `${(window.innerHeight - 300).toString()}px`,
                functionList: []
            };
        },

        computed: {
            ...mapGetters(['getUserInfo', 'getLocale']),

            userInfo() {
                return this.getUserInfo;
            },

            rows() {
                return this.functionResultsList.length;
            }
        },
        async created() {
            nprogress.start();
            this.loading = true;
            // Get all the data from the backend
            await this.$_getProducts();
            await this.$_getProductAssignments();
            this.loading = false;
            nprogress.done();
        },
        mounted() {
            // to update b-table max-height to have a freeze header (sticky-header makes fixed max-height only regardless the screen height)
            // placed a new issue in Git, see if we get any response.
            this.$nextTick(() => {
                window.addEventListener('resize', () => {
                    // debugger
                    this.btableMaxHeight = `${(
                        window.innerHeight - 300
                    ).toString()}px`; // where offset is some kind of constant margin you need from the top
                });
            });
        },
        beforeDestroy() {
            window.removeEventListener('resize', () => {});
        },

        methods: {
            async $_created() {
                await this.$_getProducts();
                await this.$_getProductAssignments();
            },
            $_productCreate() {
                this.launchProductCreate = !this.launchProductCreate;
            },
            $_assign(record) {
                this.selectedProduct = record;
                this.launchProductAssign = !this.launchProductAssign;
            },
            $_import() {
                this.launchProductImport = !this.launchProductImport;
            },
            async $_export(record) {
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetProductContent',
                    data: {
                        productId: record.productId,
                        version: record.version
                    }
                });

                const productContent = result.data;

                const totalExport = {
                    productName: record.name,
                    productVersion: record.version,
                    productContent: JSON.parse(productContent)
                };

                const blob = new Blob([JSON.stringify(totalExport, null, 2)], {
                    type: 'application/json'
                });
                const url = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = this.$_sanitizeFilename(record.name); // Desired file name
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                URL.revokeObjectURL(url); // Clean up
            },

            $_sanitizeFilename(name) {
                return name
                    .replace(/[/\\:*?"<>|]/g, '') // Remove illegal characters
                    .replace(/\s+/g, '_') // Optionally replace spaces with underscores
                    .trim();
            },
            async $_getProducts(functionName) {
                nprogress.start();
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetProductsOverview',
                    parameters: { Function: functionName }
                });
                this.productVersions = result.data ?? [];

                nprogress.done();
            },
            async $_getProductAssignments(functionName) {
                nprogress.start();
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetProductAssignments',
                    parameters: { Function: functionName }
                });
                this.organizationProductContents = result.data ?? [];

                nprogress.done();
            },
            async $_delete(record) {
                const data = {
                    message: this.$t('product.deletionConfirmation')
                };
                this.msgBoxConfirm(data).then(async (confirmed) => {
                    if (confirmed) {
                        try {
                            await this.$store.dispatch('useApiData', {
                                name: 'DeleteProductVersion',
                                data: {
                                    productId: record.productId,
                                    version: record.version
                                }
                            });
                            const data = {
                                message: this.$t('product.deleteSuccess'),
                                variant: 'success',
                                autoHideDelay: 3000
                            };
                            this.showToast(data);
                            await this.$_getProducts();
                        } catch (error) {
                            this.showToast({
                                message: this.$t(error.data.response.data.message),
                                variant: 'danger',
                                autoHideDelay: 5000,
                                noCloseButton: true
                            });
                        }
                    }
                });
            },
            async $_deleteAssignment(record) {
                const data = {
                    message: this.$t('product.deleteAssignmentConfirmation')
                };
                this.msgBoxConfirm(data).then(async (confirmed) => {
                    if (confirmed) {
                        try {
                            await this.$store.dispatch('useApiData', {
                                name: 'DeleteProductAssignment',
                                data: {
                                    productId: record.productId,
                                    version: record.version,
                                    organizationId: record.organizationId
                                }
                            });
                            const data = {
                                message: this.$t('product.deleteSuccess'),
                                variant: 'success',
                                autoHideDelay: 3000
                            };
                            this.showToast(data);
                            await this.$_getProductAssignments();
                        } catch (error) {
                            this.showToast({
                                message: this.$t(error.data.response.data.message),
                                variant: 'danger',
                                autoHideDelay: 5000,
                                noCloseButton: true
                            });
                        }
                    }
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
.tableFixHead {
    overflow-y: auto; /* make the table scrollable if height is more than 200 px  */
    height: 90%; /* gives an initial height of 200px to the table */
}

.tableFixHead thead-class th {
    position: sticky; /* make the table heads sticky */
    top: 0px; /* table head will be placed from the top of the table and sticks to it */
}

table {
    border-collapse: collapse; /* make the table borders collapse to each other */
    width: 100%;
}

thead-class,
td {
    padding: 8px 16px;
    border: 1px solid #ccc;
    position: sticky;
}

thead-class {
    background: #eee;
}
</style>
